export const routes = ['/', '/checkin', '/profile'];

export const language = 'cn';